import axios from 'axios'
import qs from 'qs'
import { Toast } from 'vant'
import Vue from 'vue'
Vue.use(Toast)

// 创建axios实例
const service = axios.create({
  baseURL: 'https://cyl.safesport.cn', // api的base_url
  timeout: 50000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
  if (config.data) {
    config.data = qs.stringify(config.data)
  }
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

export default service



// WEBPACK FOOTER //
// ./src/utils/insureRequest.js